import {
  UserAddOutlined,
  UserOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";

import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React from "react";
import { post, get, put } from "../Libraries/Ajax/HttpService";
import { Component } from "react";
import "react-toastify/dist/ReactToastify.css";

import { Modal, Input, Radio, Space, Checkbox } from "antd";
import { toast } from "react-toastify";
import back from "../assets/images/back.svg";
import { withNavigation } from "./withNavigation";
class Profile extends Component {
  state = {
    names: "",
    name: "",
    active: true,
    type: "",
    types: "",
    values: "",
    frequency: "",
    newpassword: "",
    confirmpassword: "",
    opens: false,
    open: false,
    openss: false,
    opensss: false,
    modalpassword: "",
    modalText: "",
    modalType: "",
    usertype: "",
    usercode: "",
    usertypes: "",
    colour: "",
    colours: "",
    color: [],
    color1: [],
    color3: [],
    modalFrequency: "",
    userids: "",
    email: "",
    otp: "",
    value: "",
    modalDistrict: "",
  };

  handleCheckboxChange = (value) => {
    const districts = this.state.modalDistrict;
    console.log("value ----sachin ------>", value);
    console.log("districts ----sachin ------>", districts);
    const updatedDistricts = [...districts];

    if (updatedDistricts.includes(value)) {
      updatedDistricts.splice(updatedDistricts.indexOf(value), 1);
    } else {
      updatedDistricts.push(value);
    }

    this.setState({ modalDistrict: updatedDistricts });
    console.log("aaa", updatedDistricts);
  };
   
  componentDidMount() {
    //  const isMizuWatch = window.location.href.includes("mizuwatch.com");
    // document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    this.setState({ userids: userid });
    get(`apis/color/list`).then((response) => {
      console.log("llll", response.data);
      this.setState({ color: response.data.data[0].color_list });
      this.setState({ color1: response.data.data[1].color_list });
      this.setState({ color3: response.data.data[2].color_list });
    });

    get(`apis/user_profile?user_id=${userid}`).then((response) => {

      const districts = response.data.data.districts;
      const cleanedDistricts =
        typeof districts === "string"
          ? districts.replace(/[{}]/g, "").split(",")
          : [];
      console.log(
        "sdistricts -aa--------------------------->>",
        cleanedDistricts
      );
      this.setState({
        names: response.data.data.first_name,
        type: response.data.data.last_name,
        values: response.data.data.email,
        usertype: response.data.data.user_type,
        usercode: response.data.data.user_type_code,
        colours: response.data.data?.color,
        modalDistrict: cleanedDistricts,

        //   frequency:response.data.data.
      });
      this.setState({
        name: response.data.data.first_name,
        types: response.data.data.last_name,
        values: response.data.data.email,
        usertypes: response.data.data.user_type,
        colour: response?.data?.data?.color,
        modalDistrict: cleanedDistricts,
        //   frequency:response.data.data.
      });
    });
  }
  onNamesChange = (e) => {
    this.setState({
      name: e.target.value,
    });
  };
  onselectClicks = (e) => {
    this.props.navigate("/registration");
  };
  onselectClick = (e) => {
    this.props.navigate("/list");
  };
  onselectClickss = (e) => {
    // this.props.history.push('/dashboard');
    // window.history.back();
    this.props.navigate(-1);
  };

  onTypeChange = (e) => {
    this.setState({
      types: e.target.value,
    });
  };
  onemailChange = (e) => {
    this.setState({
      email: e.target.value,
    });
  };
  onValueChange = (e) => {
    this.setState({
      values: e.target.value,
    });
  };
  onFrequencyChange = (e) => {
    this.setState({
      frequency: e.target.value,
    });
  };
  onotpChange = (e) => {
    this.setState({
      otp: e.target.value,
    });
  };
  onpasswordChange = (e) => {
    this.setState({
      newpassword: e.target.value,
    });
  };
  onconfirmpasswordChange = (e) => {
    this.setState({
      confirmpassword: e.target.value,
    });
  };
  handleCancel = () => {
    console.log("Clicked cancel button");
    this.setState({
      opens: false,
    });
  };
  onMouseClick = (event) => {
    this.setState({
      usercode: event.target.value,
    });
  };

  onMouseClicks = (event) => {
    this.setState({
      colour: event.target.value,
    });
  };
  handleCancels = () => {
    console.log("Clicked cancel button");
    this.setState({
      open: false,
    });
  };
  handleCancelss = () => {
    console.log("Clicked cancel button");
    this.setState({
      openss: false,
    });
  };
  handleCancelsss = () => {
    console.log("Clicked cancel button");
    this.setState({
      opensss: false,
    });
  };

  handleSubmit = () => {
    console.log("Clicked cancel button");
    this.setState({
      opens: true,
    });
  };

  onChange = (e) => {
    console.log("radio checked", e.target.value);
    this.setState({
      colour: e.target.value,
    });
  };

  handleSubmits = (e) => {
    e.preventDefault();
    console.log("Clicked cancel button");
    this.setState({
      open: true,
    });
    this.setState({
      openss: false,
    });
    this.setState({
      opensss: false,
    });
    this.setState({
      name: this.state.names,
    });
    this.setState({
      types: this.state.type,
    });
  };
  handleSubmitss = (e) => {
    e.preventDefault();
    console.log("Clicked cancel button");
    this.setState({
      openss: true,
    });
    this.setState({
      open: false,
    });
    this.setState({
      opensss: false,
    });
  };
  handleSubmitsss = (e) => {
    e.preventDefault();
    console.log("Clicked cancel button");
    this.setState({
      opensss: true,
    });
  };

  handleOks = (e) => {
    e.preventDefault();

    const data = {
      first_name: this.state.name,
      last_name: this.state.types,
      user_id: this.state.userids,
      user_type: this.state.usercode,
      color: this.state.colour,
      districts: this.state.modalDistrict,

      // old_password: this.state.frequency,
      // new_password:this.state.newpassword,
      // confirm_password:this.state.confirmpassword
    };

    console.log("data", data);
    post("apis/user_edit_profile", data).then(
      (response) => {
        console.log("datadddddddddddd", response);

        setTimeout(() => {
          toast.success(response.data.message);
        }, 1000);

        setTimeout(() => {
          // this.props.history.push('/profile');
          this.props.navigate(0);
        }, 2000);
      },
      (error) => {
        toast.error(error.response.data.msg, {
          autoClose: 3000,
        });
      }
    );
  };

  handleOk = (e) => {
    e.preventDefault();

    const data = {
      first_name: this.state.names,
      last_name: this.state.type,
      username: this.state.values,
      old_password: this.state.frequency,
      new_password: this.state.newpassword,
      confirm_password: this.state.confirmpassword,
    };
    console.log("data", data);
    put("apis/change_password", data).then(
      (response) => {
        console.log("data", data);

        setTimeout(() => {
          toast.success(response.data.message);
        }, 1000);

        setTimeout(() => {
          this.props.history.go(0);
        }, 2000);

        this.props.history.go(0);
      },
      (error) => {
        toast.error(error.response.data.msg, {
          autoClose: 3000,
        });
      }
    );
  };
  handleOkss = (e) => {
    e.preventDefault();

    post(
      `apis/change_email?old_email=${this.state.values}&email=${this.state.email}`
    ).then(
      (response) => {
        setTimeout(() => {
          toast.success(response.data.msg);
        }, 1000);
        if (
          response.data.msg.toString().toLowerCase().includes("already exists")
        ) {
          this.setState({ opensss: false });
          this.setState({ openss: true });
        } else {
          this.setState({ opensss: true });
          this.setState({ openss: false });
        }
      },
      (error) => {
        toast.error(error.response.data.msg, {
          autoClose: 3000,
        });
      }
    );
  };
  handleOksss = (e) => {
    e.preventDefault();

    const data = {
      old_email: this.state.values,
      otp: this.state.otp,
    };
    console.log("data", data);
    post("apis/change_email_otp_confirm", data).then(
      (response) => {
        console.log("data", data);

        setTimeout(() => {
          toast.success("Email Changed Successfully");
        }, 1000);

        setTimeout(() => {
          this.props.history.go(0);
        }, 2000);
      },
      (error) => {
        toast.error(error.response.data.msg, {
          autoClose: 3000,
        });
      }
    );
  };

  render() {
    return (
      <>
        {/* <ToastContainer /> */}
         {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
        <Header />
        <Main>
          <div>
            <div className="d-flex align-items-center flex-wrap justify-content-between">
              <div className="d-flex align-items-center">
                <img
                  src={back}
                  alt=""
                  style={{ width: "10px", cursor: "pointer" }}
                  onClick={this.onselectClickss}
                />
                <h3 className="mb-0 ms-3">User Profile</h3>
              </div>
            </div>
          </div>

          <div className="post">
            <form className="form-horizontal bg-white mx-auto login-form rounded p-5 border-2 shadow my-3">
              <div className="col-lg-6 m-auto">
                <div className="col-12 position-relative">
                  <div className="title-style">
                    <p>First Name</p>
                  </div>
                  <h6 className="profile-details">{this.state.names} </h6>
                </div>

                <div className="col-12 position-relative  mt-5">
                  <div className="title-style">
                    <p>Last Name</p>
                  </div>
                  <h6 className="profile-details">{this.state.type} </h6>
                </div>

                <div className="col-12 position-relative  mt-5">
                  <div className="title-style">
                    <p>Email</p>
                  </div>
                  <h6 className="profile-detail">{this.state.values} </h6>
                </div>
                <div className="col-12 position-relative  mt-5">
                  <div className="title-style">
                    <p>User Type</p>
                  </div>
                  <h6 className="profile-detail">{this.state.usertype} </h6>
                </div>
                <div className="col-12 position-relative  mt-5">
                  <div className="title-style">
                    <p>Colour Palette</p>
                  </div>
                  <h6 className="profile-detail">
                    <span className="color-palette-section ">
                      {((value) => {
                        if (value === "Color Palette 1") {
                          return "Sky D3";
                        } else if (value === "Color Palette 2") {
                          return "Positive colours";
                        } else if (value === "Color Palette 3") {
                          return "Google colours";
                        } else {
                          return this.state?.colour;
                        }
                      })(this.state?.colour)}
                      {this.state?.colour === "Color Palette 1"
                        ? this.state.color?.slice(0, 10)?.map((name, index) => (
                            <span
                              className="palette-box ms-2"
                              style={{ background: name }}
                            >
                              {" "}
                            </span>
                          ))
                        : this.state.colour === "Color Palette 2"
                        ? this.state.color1.slice(0, 10).map((name, index) => (
                            <span
                              className="palette-box ms-2"
                              style={{ background: name }}
                            >
                              {" "}
                            </span>
                          ))
                        : this.state.colour === "Color Palette 3"
                        ? this.state.color3.slice(0, 10).map((name, index) => (
                            <span
                              className="palette-box ms-2"
                              style={{ background: name }}
                            >
                              {" "}
                            </span>
                          ))
                        : ""}
                    </span>
                  </h6>
                </div>

                <div className="form-group mb-3 mt-5">
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      className="btn btn-submit mt-0 fs-16 me-3 px-2"
                      onClick={this.handleSubmits}
                    >
                      Edit Profile Details
                    </button>
                    {/* <button type="submit" className="btn btn-submit mt-0 fs-16">Submit</button> */}
                    <button
                      type="submit"
                      className="btn btn-submit mt-0 fs-16 me-3"
                      onClick={this.handleSubmitss}
                    >
                      Edit Email
                    </button>
                    <button
                      type="button"
                      className="btn btn-submit mt-0 fs-16"
                      onClick={this.handleSubmit}
                    >
                      Edit Password
                    </button>
                  </div>
                </div>
              </div>
            </form>
            {this.state.opens === true ? (
              <Modal
                open={this.state.opens}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                centered="true"
                okText="Update"
              >
                <form className="form-horizontal bg-white mx-auto p-3 login-form">
                  <div className="forms-inputs mt-3">
                    <span for="pwd">Old Password</span>
                    <input
                      type="password"
                      className="form-control"
                      id="pwd"
                      placeholder="Enter Old Password"
                      defaultValue={this.state.frequency}
                      onChange={this.onFrequencyChange}
                    />
                  </div>
                  <div className="forms-inputs">
                    <span for="pwd">New Password</span>
                    <input
                      type="password"
                      className="form-control"
                      id="pwd"
                      placeholder="Enter New Password"
                      defaultValue={this.state.newpassword}
                      onChange={this.onpasswordChange}
                    />
                  </div>
                  <div className="forms-inputs">
                    <span for="email">Confirm Password</span>
                    <input
                      type="password"
                      className="form-control"
                      id="email"
                      placeholder="Confirm New Password"
                      defaultValue={this.state.confirmpassword}
                      onChange={this.onconfirmpasswordChange}
                    />
                  </div>
                </form>
              </Modal>
            ) : (
              ""
            )}
            {this.state.open === true ? (
              <Modal
                open={this.state.open}
                onOk={this.handleOks}
                onCancel={this.handleCancels}
                centered="true"
                okText="Update"
              >
                <form className="form-horizontal bg-white mx-auto p-3 login-form">
                  <div className="forms-inputs mt-3">
                    <span for="pwd">First Name</span>
                    <input
                      type="text"
                      className="form-control"
                      id="pwd"
                      placeholder="Edit First Name"
                      defaultValue={this.state.names}
                      onChange={this.onNamesChange}
                    />
                  </div>
                  <div className="forms-inputs">
                    <span for="pwd">Last Name</span>
                    <input
                      type="text"
                      className="form-control"
                      id="pwd"
                      placeholder="Edit Last Name"
                      defaultValue={this.state.type}
                      onChange={this.onTypeChange}
                    />
                  </div>

                  {this.state.usertype === "Super Admin" && (
                    <select
                      name="All meters"
                      id="selector"
                      className="box w-100 mb-4"
                      style={{ height: "49px", fontWeight: 400 }}
                      onChange={this.onMouseClick}
                      placeholder="Change User Type"
                    >
                      <option value="" disabled selected>
                        Change User Type
                      </option>
                      <option
                        value="SA"
                        selected={
                          this.state.usertype === "Super Admin" ? true : false
                        }
                      >
                        Super Admin
                      </option>
                      <option
                        value="A"
                        selected={
                          this.state.usertype === "Admin" ? true : false
                        }
                      >
                        Admin{" "}
                      </option>
                      <option
                        value="U"
                        selected={this.state.usertype === "User" ? true : false}
                      >
                        User
                      </option>
                    </select>
                  )}

                  {/* {this.state.usercode === "SA" && (
                    <div className="col-md-4 mt-5">
                      <h6
                        className="w-100 total-flow-font-size"
                        style={{ color: "#515252" }}
                      >
                        <b>District Selection</b>
                      </h6>
                      <div className="form-check ps-0 d-flex align-items-center mt-3">
                        <Checkbox
                          value="1"
                          onChange={() => this.handleCheckboxChange("1")}
                          checked={this.state.modalDistrict.includes("1")}
                        >
                          <span className="ms-2" style={{ color: "#515252" }}>
                            <b>GPMD</b>
                          </span>
                        </Checkbox>
                        <Checkbox
                          value="2"
                          onChange={() => this.handleCheckboxChange("2")}
                          checked={this.state.modalDistrict.includes("2")}
                        >
                          <span className="ms-2" style={{ color: "#515252",whiteSpace: 'nowrap' }}>
                            <b>FB 151</b>
                          </span>
                        </Checkbox>
                        <br /> <br /> <br />
                      </div>
                    </div>
                  )} */}

                  <div className="">
                    <div className="mt-0">
                      <h6>Change Palette</h6>
                      <Radio.Group
                        onChange={this.onChange}
                        defaultValue={this.state.colour}
                      >
                        <Space direction="vertical">
                          <Radio
                            value="Color Palette 1"
                            checked={
                              this.state.colour === "Color Palette 1"
                                ? "true"
                                : "false"
                            }
                          >
                            {" "}
                            <span className="color-palette-section ">
                              {" "}
                              Sky D3
                              {/* <span className="palette-box ms-2"> </span>  */}
                              {this.state.color
                                .slice(0, 10)
                                .map((name, index) => (
                                  <span
                                    className="palette-box ms-2"
                                    style={{ background: name }}
                                  >
                                    {" "}
                                  </span>
                                ))}
                            </span>
                          </Radio>
                          <Radio
                            value="Color Palette 2"
                            checked={
                              this.state.colour === "Color Palette 2"
                                ? "true"
                                : "false"
                            }
                          >
                            <span className="color-palette-section ">
                              Positive Colours
                              {this.state.color1
                                .slice(0, 10)
                                .map((name, index) => (
                                  <span
                                    className="palette-box ms-2"
                                    style={{ background: name }}
                                  >
                                    {" "}
                                  </span>
                                ))}
                            </span>
                          </Radio>

                          <Radio
                            value="Color Palette 3"
                            checked={
                              this.state.colour === "Color Palette 3"
                                ? "true"
                                : "false"
                            }
                          >
                            <span className="color-palette-section ">
                              {" "}
                              Google Colours
                              {this.state.color3
                                .slice(0, 10)
                                .map((name, index) => (
                                  <span
                                    className="palette-box ms-2"
                                    style={{ background: name }}
                                  >
                                    {" "}
                                  </span>
                                ))}
                            </span>
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </div>
                    {/*  */}
                  </div>
                </form>
              </Modal>
            ) : (
              ""
            )}
            {this.state.openss === true ? (
              <Modal
                open={this.state.openss}
                onCancel={this.handleCancelss}
                footer={null}
              >
                <form
                  className="form-horizontal bg-white mx-auto p-3 login-form"
                  onSubmit={this.handleOkss}
                >
                  <div className="forms-inputs mt-3">
                    <span for="email">Email</span>
                    <input
                      type="email"
                      className="form-control"
                      id="pwd"
                      placeholder="Edit Email"
                      defaultValue={this.state.values}
                      required
                      disabled
                    />
                  </div>
                  <div className="forms-inputs">
                    <span for="email">New Email</span>
                    <input
                      type="email"
                      className="form-control"
                      id="pwd"
                      placeholder="Enter New Email"
                      defaultValue={this.state.email}
                      required
                      onChange={this.onemailChange}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <div className="col-sm-offset-2">
                      <button
                        type="submit"
                        className="btn w-100 btn-submit fs-20 mt-20"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </Modal>
            ) : (
              ""
            )}
            {this.state.opensss === true ? (
              <Modal
                open={this.state.opensss}
                onOk={this.handleOksss}
                onCancel={this.handleCancelsss}
                centered="true"
                okText="Update"
              >
                <form className="form-horizontal bg-white mx-auto py-3 login-form">
                  <div className="forms-inputs">
                    <span for="pwd">Enter OTP</span>
                    <input
                      type="text"
                      className="form-control"
                      id="pwd"
                      placeholder="Enter OTP"
                      defaultValue={this.state.otp}
                      onChange={this.onotpChange}
                    />
                  </div>
                </form>
              </Modal>
            ) : (
              ""
            )}
          </div>
        </Main>
      </>
    );
  }
}

// export default Profile;
export default withNavigation(Profile);
